<template>
  <div class="work-order-detail">
    <el-row :gutter="20">
      <el-col :span="12">
        <work-order-status-info
          :work-order="wkDetailInfo"
        ></work-order-status-info>
        <work-order-base-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-base-info>
        <work-order-apply-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-apply-info>
        <work-order-user-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-user-info>
        <work-order-more-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-more-info>
      </el-col>
      <el-col :span="12" v-if="hasPermission">
        <el-card style="margin-bottom: 10px">
          <work-order-process :work-order="wkDetailInfo"></work-order-process>
        </el-card>
      </el-col>
    </el-row>
    <temp-dialog></temp-dialog>
  </div>
</template>

<script>
import api from "plus/api";

export default {
  name: "workmange.workOrderList.workOrderRelationDetail",
  components: {},
  data() {
    return {
      wkDetailInfo: {},
      hasPermission: false,
    };
  },
  computed: {
    wkOrderId() {
      return this.$route.query.wkOrderId;
    },
    isClosed() {
      return parseInt(this.wkDetailInfo.status) === 2;
    },
    isReject() {
      return parseInt(this.wkDetailInfo.status) === 3;
    },
  },
  activated() {
    this.getWkOrderInfo();
  },
  deactivated() {
    this.resetData();
  },
  methods: {
    resetData() {
      this.wkDetailInfo = {};
    },
    getWkOrderInfo() {
      return api.workmanage
        .getWorkDetailByWorkOrderId({ workOrderId: this.wkOrderId })
        .then((res) => {
          this.hasPermission = true;
          const data = res.data.data;
          this.wkDetailInfo = data;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.work-order-detail {
  width: 100%;

  .detail-header {
    width: 100%;
    background: #fff;
  }

  .transfer-info {
    padding-bottom: 28px;

    .transfer-container {
      padding-left: 19px;

      .transfer-item {
        margin: 20px 0;
        height: 22px;
        line-height: 22px;
        font-size: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        .transfer-item-text {
          margin-right: 10px;
        }

        /*.color-green {
          margin-right: 5px;
        }

        .color-blue {
          margin-right: 10px;
        }*/
      }
    }
  }

  .record {
    width: 100%;

    .record-container {
      padding-left: 16px;
      box-sizing: border-box;
    }
  }

  .transfer-way {
    padding-bottom: 84px;

    .transfer-form {
      padding-top: 20px;
      border-top: 1px solid #e2e2e2;

      .el-textarea {
        width: 540px;

        /deep/ .el-textarea__inner {
          padding-bottom: 20px !important;
        }

        /deep/ .el-input__count {
          line-height: normal !important;
          right: 20px;
        }
      }

      .el-button {
        width: 104px;
        height: 36px;
        font-size: 14px;
      }
    }
  }
}
</style>
